// extracted by mini-css-extract-plugin
module.exports = {"pg-auth-header":"styles_pg-auth-header__1wG98","login":"styles_login__17_ZQ","signup":"styles_signup__2ZobU","pg-auth":"styles_pg-auth__1Wkah"};